import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { branchEnvironmentActions } from '@app/redux/branchEnvironment/branchEnvironment.reducer';
import { useAppDispatch } from '@app/redux/hooks';

import { getBranchRoutes, getDefaultBranch } from '@utils/environment';

function useBranchEnvironment() {
	const dispatch = useAppDispatch();
	const { pathname } = useLocation();

	useEffect(() => {
		const params = pathname.split('/').filter(param => param !== '');
		const branchRouteParams = params[0];
		const repRouteParam = params[1];
		const defaultBranch = getDefaultBranch();
		if (defaultBranch.is_branch_from_query_params) {
			dispatch(branchEnvironmentActions.setBranchEnvironment(defaultBranch));
		} else {
			const branchEnvironment = getBranchRoutes().find(
				route => route.branch_route === branchRouteParams && route.rep_route === repRouteParam,
			);

			if (branchEnvironment) {
				dispatch(branchEnvironmentActions.setBranchEnvironment(branchEnvironment));
			}
		}
	}, [dispatch, pathname]);
}

export default useBranchEnvironment;
